import store from '../store'
import * as Req from '@/api/index.js'
import { BASE_URL, SERVE_SITE_URL } from '@/api/base.js'
import { isLogin } from '@/util/index.js'
import router from '../router'

export function fetchAreaLevel(id) {
  let dataObj = {}
  if (id === 0) {
    dataObj.areaLevel = 1
  } else {
    dataObj.parentId = id
  }
  return Req.Get(`${SERVE_SITE_URL}/Area/List`, dataObj)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchUserInfo() {
  return Req.GetWithHeader(`${BASE_URL}/Partner/UserInfo`, {})
    .then((res) => {
      if (!res.success) {
        router.push('/login')
        return 
      }
      store.commit('SET_ACCOUNTDATA', res.response)
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchAccountData() {
  return new Promise((resolve, reject) => {
    if (Object.keys(store.state.accountData).length) {
      resolve(store.state.accountData)
    } else {
      fetchUserInfo().then((res) => {
        if (res.success) {
          resolve(res.response)
          store.commit('SET_ACCOUNTDATA', res.response)
        } else {
          resolve({})
        }
      })
    }
  })
}
export function fetchDeliveryInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/Logistics`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function uploadUserAvatar(url) {
  return Req.PostWithHeader(`${BASE_URL}/Partner/UploadLogo`, {
    logoUrl: url
  }).then((res) => {
    return Promise.resolve(res)
  }).catch((err) => {
    console.log(err.response)
  })
}

export function fetchMobileVcode(data) {
  return Req.Get(`${SERVE_SITE_URL}/VerifyCode/GetMobileVerifyCode`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchInviteServePic(data) {
  return Req.PostWithHeader(`${BASE_URL}/Partner/GetInvitePoster`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchQrImageByLink(link, size) {
  return Req.GetWithHeader(`${BASE_URL}/Public/GetQrImageByLink`, {
    link,
    size: size || 1
  })
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchOrderReport() {
  return Req.GetWithHeader(`${BASE_URL}/Data/OrderReport`, null)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchUserReport() {
  return Req.GetWithHeader(`${BASE_URL}/Data/UserReport`, null)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchBusinessLayeredReport() {
  return Req.GetWithHeader(`${BASE_URL}/Data/BusinessLayeredReport`, null)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchBusinessLayeredList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/BusinessLayeredList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchBusinessBrowsingList(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/BusinessBrowsingList'
  }
  if (type === 2) {
    url = '/Data/BusinessButler_BusinessBrowsingList'
  }
  return Req.GetWithHeader(`${BASE_URL}${url}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchPurchaseRewardProductList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/PurchaseRewardProductList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchPurchaseStandardSettingList() {
  return Req.GetWithHeader(`${BASE_URL}/Partner/PurchaseStandardSettingList`, {})
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchPurchaseStandardBusinessList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/PurchaseStandardBusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchPurchaseRewardProductDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/PurchaseRewardProductDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchSuppliersList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/SuppliersList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchPurchaseButlerStandardSettingList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/PurchaseButlerStandardSettingList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchPurchaseButlerStandardSuppliersList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/PurchaseButlerStandardSuppliersList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchSuppliersBusinessList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/SuppliersBusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchProductPurchaseRecord(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/ProductPurchaseRecord`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchProductPurchaseRecordDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/ProductPurchaseRecordDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function fetchSuppliersListByMonth(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/SuppliersListByMonth`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
// 首页
export function fetchTodayOrderData(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/Business_TodayOrderData'
  }
  if (type === 2) {
    url = '/Data/BusinessButler_TodayOrderData'
  }
  return Req.GetWithHeader(`${BASE_URL}${url}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchWeekOrMonthOrderData(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/Business_WeekOrMonthOrderData'
  }
  if (type === 2) {
    url = '/Data/BusinessButler_WeekOrMonthOrderData'
  }
  return Req.GetWithHeader(`${BASE_URL}${url}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchWeekOrMonthOrderLineChart(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/Business_WeekOrMonthOrderLineChart'
  }
  if (type === 2) {
    url = '/Data/BusinessButler_WeekOrMonthOrderLineChart'
  }
  return Req.GetWithHeader(`${BASE_URL}${url}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchButlerSubSuppliersTotal(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/BusinessButler_SubSuppliersTotal`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchButlerSubSuppliers(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/BusinessButler_SubSuppliers`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchUserWithOrderList(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/Business_UserWithOrderList'
  }
  if (type === 2) {
    url = '/Data/BusinessButler_UserWithOrderList'
  }
  return Req.GetWithHeader(`${BASE_URL}${url}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchBusinessButlerTopThree(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/BusinessButler_TopThree`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchOverview(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/Business_Overview'
  } else if (type === 2) {
    url = '/Data/BusinessButler_Overview'
  } else {
    url = '/Data/Overview'
  }
  return Req.GetWithHeader(`${BASE_URL}${url}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchBusinessSubPartner(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/BusinessButler_SubPartner`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchSubBusiness(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/Business_SubBusiness'
  } else if (type === 2) {
    url = '/Data/BusinessButler_SubBusiness'
  } else {
    url = '/Data/SubBusiness'
  }
  return Req.GetWithHeader(`${BASE_URL}${url}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchSubBusinessByMonth(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/Business_SubBusinessByMonth'
  } else if (type === 2) {
    url = '/Data/BusinessButler_SubBusinessByMonth'
  } else {
    url = '/Data/SubBusinessByMonth'
  }
  return Req.GetWithHeader(`${BASE_URL}${url}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchNewBusinessLayeredList(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/NewBusinessLayeredList'
  } else if (type === 2) {
    url = '/Data/BusinessButler_NewBusinessLayeredList'
  } else {
    url = '/Data/NewBusinessLayeredList'
  }
  return Req.GetWithHeader(`${BASE_URL}${url}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function postLayeredRecord(type, data) {
  let url = ''
  if (type === 1) {
    url = '/Data/LayeredRecord'
  } else if (type === 2) {
    url = '/Data/BusinessButler_LayeredRecord'
  } else {
    url = '/Data/LayeredRecord'
  }
  return Req.PostWithHeader(`${BASE_URL}/Data/LayeredRecord`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

// 管理员
export function adminTodayOrder(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/TodayOrder`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function adminSaleOrder(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/SaleOrder`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function adminBusinessData(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/BusinessData`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function adminRepurchaseRate(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/RepurchaseRate`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function adminActiveRate(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/ActiveRate`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function adminNewConversionRate(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/NewConversionRate`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function adminPartnerData(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/PartnerData`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function adminGetPartnerArea(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerArea`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function todayOrderUserList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/TodayOrderUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function todayOrderList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/TodayOrderList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function saleOrderAreaList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/SaleOrderAreaList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function adminBusinessList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/BusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function repurchaseBusinessList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/RepurchaseBusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function activeBusinessList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/ActiveBusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function partnerAreaList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/PartnerAreaList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function partnerUserList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/PartnerUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function activePartnerUserList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/ActivePartnerUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function businessAreaList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/BusinessAreaList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function saleOrderList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/SaleOrderList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessOrderAreaList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/BusinessOrderAreaList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessOrderBusinessAreaList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/BusinessOrderBusinessAreaList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessOrderOrderAreaList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/BusinessOrderOrderAreaList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
// 普通合伙人旗下商家总览
export function SubBusinessTotal(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/SubBusinessTotal`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
//  代理商合伙人旗下商家/合伙人总览
export function AgentSubBusinessTotal(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/AgentSubBusinessTotal`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
// 合伙人旗下商家列表(代理商合伙人/代理商旗下合伙人/普通合伙人 公用) 
export function SubBusinessList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/SubBusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
// 代理商旗下合伙人列表
export function SubPartnerList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/SubPartnerList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}


// 新渠道商合伙人旗下商家列表
export function NewChannelSubBusinessList(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/NewChannelSubBusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
// 新渠道商合伙人旗下商家总览
export function NewChannelSubBusinessTotal(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/NewChannelSubBusinessTotal`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
// 新版合伙人数据
export function GetHomeData(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/GetHomeData?v=${new Date().getTime().toString().substr(10, 3)}`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function PrepareApplicationPageList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/PrepareApplicationPageList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function CancelInvoiceApplication(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/CancelInvoiceApplication`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ComplateInvoiceInfo(data) {
  return Req.PostWithHeader(`${BASE_URL}/Partner/ComplateInvoiceInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetFollowUpOverview(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/GetFollowUpOverview`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetFollowUpClueList(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/GetFollowUpClueList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetExpandOverview(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/GetExpandOverview`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetBusinessUserList(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/GetBusinessUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPosterGroupList(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/GetPosterGroupList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPosterList(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/GetPosterList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPlaceOrderOverview(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/GetPlaceOrderOverview`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function SetNickName(data) {
  return Req.PostWithHeader(`${BASE_URL}/DailyWork/SetNickName`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetBusinessUserContactInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/ReportData/GetBusinessUserContactInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetBusinessUserPlaceOrderInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/ReportData/GetBusinessUserPlaceOrderInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetBusinessUserUpgradeInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/ReportData/GetBusinessUserUpgradeInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
// 获取常用品牌
export function BrandCommonlyList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Product_Brand/CommonlyList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
// 获取全部品牌
export function BrandList(data) {
  return Req.Get(`${BASE_URL}/Product_Brand/List`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
// 获取品类
export function ProductTypeTreeList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Product_Type/TreeList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function CommodityMatchBizList(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/CommodityMatchBizList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function CommodityResourceList(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/CommodityResourceList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function CommodityResourcePoolInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/CommodityResourcePoolInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetReportDataBusinessUserList(data) {
  return Req.GetWithHeader(`${BASE_URL}/ReportData/GetBusinessUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function MakingCall(data) {
  return Req.PostWithHeader(`${BASE_URL}/DailyWork/MakingCall`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function RewardInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/RewardInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function RewardList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/RewardList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function EntryRewardInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/EntryRewardInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function EntryRewardBusinessUserList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/EntryRewardBusinessUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function UpgradeRewardInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/UpgradeRewardInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function UpgradeRewardBusinessUserList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/UpgradeRewardBusinessUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function MajorApplianceGmvRewardInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/MajorApplianceGmvRewardInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function MajorApplianceGmvRewardBusinessUserList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/MajorApplianceGmvRewardBusinessUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BaseRewardInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/BaseRewardInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BaseRewardChildOrderList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/BaseRewardChildOrderList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GmvRewardInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/GmvRewardInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GmvRewardChildOrderList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/GmvRewardChildOrderList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

export function BaseRewardDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/BaseRewardDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function EntryRewardDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/EntryRewardDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GmvRewardDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/GmvRewardDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function MajorApplianceGmvRewardDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/MajorApplianceGmvRewardDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function UpgradeRewardDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/UpgradeRewardDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessUserOverview(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/BusinessUserOverview`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GmvOverView(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/GmvOverView`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function DailyWorkChildOrderList(data) {
  return Req.GetWithHeader(`${BASE_URL}/DailyWork/ChildOrderList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessUserReport(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/BusinessUserReport`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GmvReport(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/GmvReport`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function RewardChildOrderList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/RewardChildOrderList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ExportBusinessUserData(data) {
  return Req.PostWithHeader(`${BASE_URL}/Data/ExportBusinessUserData`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ExportBusinessUserDataRecrd(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/ExportBusinessUserDataRecrd`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function Profitability(data) {
  return Req.GetWithHeader(`${BASE_URL}/Data/Profitability`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function LevelData(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/LevelData`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function RewardGMVData(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/RewardGMVData`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function RewardLoginData(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/RewardLoginData`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function RewardRecruitmentData(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/RewardRecruitmentData`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function PartnerSpuList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/SpuList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function MatchedBizUser(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/MatchedBizUser`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ContactBizUser(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/ContactBizUser`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ContactRemarkList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/ContactRemarkList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function PartnerRemark(data) {
  return Req.PostWithHeader(`${BASE_URL}/Partner/Remark`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function PartnerStatsData(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/StatsData`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function SubordinateMerchant(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/SubordinateMerchant`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function LoginedMerchant(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/LoginedMerchant`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GMVData(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GMVData`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPosterListByType(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPosterListByType`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BonusAccount(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/BonusAccount`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function RewardInfoV2(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/v2/RewardInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function RewardRuleList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/v2/RewardRuleList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessUserListV2(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/v2/BusinessUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GmvInfoV2(data) {
  return Req.GetWithHeader(`${BASE_URL}/Reward/v2/GmvInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function fetchBanners(key, userId) {
  return Req.Get(`${BASE_URL}/Banner/GetCopartnerBannerlist?v=${new Date().getTime().toString().substr(10, 3)}`, {
    keyId: key,
    userId: userId ? userId : null
  })
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}

/////////////
export function ToDoStats(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/Stats`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ToDoUnactivatedList(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/UnactivatedList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ToDoUnimprovedList(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/UnimprovedList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ToDoUnlicensedList(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/UnlicensedList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ToDoUnpaidList(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/UnpaidList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ToDoUnpassList(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/UnpassList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
/////////////
export function ToDoLabelDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/LabelDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ToDoBrandList(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/BrandList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function ToDoTypeList(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/TypeList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function SetLable(data) {
  return Req.PostWithHeader(`${BASE_URL}/ToDo/SetLable`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function HighSeasArea(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/HighSeasArea`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function MerchantHighSeas(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/MerchantHighSeas`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function Copartner2024RewardRewardInfo(data) {
  return Req.GetWithHeader(`${BASE_URL}/Copartner/2024/Reward/RewardInfo`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function Copartner2024RewardCopartnerType(data) {
  return Req.GetWithHeader(`${BASE_URL}/Copartner/2024/Reward/CopartnerType`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function FirstOrderMerchantList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Copartner/2024/Reward/FirstOrderMerchantList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function MonthlyActivityMerchantList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Copartner/2024/Reward/MonthlyActivityMerchantList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function SilenceMerchantList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Copartner/2024/Reward/SilenceMerchantList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function PartnerRealNameGet(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/RealNameGet`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function PartnerRealNameSet(data) {
  return Req.PostWithHeader(`${BASE_URL}/Partner/RealNameSet`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function getFooterBar() {
  return new Promise((resolve, reject) => {
    const data = store.state.footerBar.footerBar
    if (data.length) {
      resolve(data)
    } else {
      Copartner2024RewardCopartnerType().then(res => {
        if (res.success) {
          // let to = ""
          // if (res.response === 1 || res.response === 2) {
          //   to = '/dataDetail'
          // } else if (res.response === 3) {
          //   to = '/homeV2/dataCenter'
          // }
          let bar = [
            { text: "工作台", to: '/homeV2/workSchedule' },
            { text: "邀请素材", to: '/homeV2/increaseRevenue' },
            { text: "驾驶舱", to: `/homeV2/merchantCenter` },
            // { text: "数据详情", to: '/dataDetail' },
            { text: "我的奖金", to: '/homeV2/bonus' },
          ]
          store.commit('footerBar/setFooterBar', bar)
          resolve(bar)
        } else {
          resolve([])
        }
      })
    }
  })
}
export function PartnerGetInviteCopartnerPoster(data) {
  return Req.PostWithHeader(`${BASE_URL}/Partner/GetInviteCopartnerPoster`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetCurrentPartnerGrade(data) {
  return Req.GetWithHeader(`${BASE_URL}/PartnerGrade/GetPartnerGrade`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerGradeSetting(data) {
  return Req.GetWithHeader(`${BASE_URL}/PartnerGrade/GetPartnerGradeSetting`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerGradeSettlement(data) {
  return Req.GetWithHeader(`${BASE_URL}/PartnerGrade/GetPartnerGradeSettlement`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessList(data) {
  return Req.GetWithHeader(`${BASE_URL}/PartnerGrade/GetPartnerBusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetChildPartnerBusinessList(data) {
  return Req.GetWithHeader(`${BASE_URL}/PartnerGrade/GetChildPartnerBusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetChildPartnerNewBusinessList(data) {
  return Req.GetWithHeader(`${BASE_URL}/PartnerGrade/GetChildPartnerNewBusinessList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetIndividualLableByPartnerDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/GetIndividualLableByPartnerDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function InformationEditByPartner(data) {
  return Req.PostWithHeader(`${BASE_URL}/ToDo/InformationEditByPartner`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetBusinessInfoByPartner(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/GetBusinessInfoByPartner`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function UnQwChatList(data) {
  return Req.GetWithHeader(`${BASE_URL}/ToDo/UnQwChatList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetTask25InfoTotal(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetTask25InfoTotal`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetTask25InfoByMonth(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetTask25InfoByMonth`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetTask25InfoUserList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetTask25InfoUserList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function SetNameRemarkPartner(data) {
  return Req.PostWithHeader(`${BASE_URL}/ToDo/SetNameRemarkPartner`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessDataOverview(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessDataOverview`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessOrderOverview(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessOrderOverview`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessLoginOverview(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessLoginOverview`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessBonusOverview(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessBonusOverview`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessWorkOrderOverview(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessWorkOrderOverview`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessDataList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessDataList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessOrderList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessOrderList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessLoginList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessLoginList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessBonusList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessBonusList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessWorkOrderList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessWorkOrderList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessWorkOrderTagList(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessWorkOrderTagList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function GetPartnerBusinessWorkOrderDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/Partner/GetPartnerBusinessWorkOrderDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessUserFPAdd(data) {
  return Req.PostWithHeader(`${BASE_URL}/BusinessUserFP/Add`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessUserFPGetList(data) {
  return Req.GetWithHeader(`${BASE_URL}/BusinessUserFP/GetList`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessUserFPGetDetail(data) {
  return Req.GetWithHeader(`${BASE_URL}/BusinessUserFP/GetDetail`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessUserFPUpdate(data) {
  return Req.PostWithHeader(`${BASE_URL}/BusinessUserFP/Update`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}
export function BusinessUserFPDelete(data) {
  return Req.GetWithHeader(`${BASE_URL}/BusinessUserFP/Delete`, data)
    .then((res) => {
      return Promise.resolve(res)
    }).catch((err) => {
      console.log(err.response)
    })
}